var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centred-full-width"},[_c('h1',{staticClass:"centred-full-width__headline"},[_vm._v(_vm._s(_vm.data.headlineText))]),_c('rich-text',{staticClass:"centred-full-width__paragraph",attrs:{"textData":_vm.data.introCopy}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }